import { Form } from "@/ui/Form";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";

export default function ({
  md = "10",
  className = "py-5 py-md-6",
  forms = null,
  theme = "light",
  custom_submission_page_url
}) {

  // Check if forms is an array and has elements
  if (!Array.isArray(forms) || forms.length === 0) {
    return null;
  }

  const [{ form_id, description, title, tagline }] = forms;

  return (
    <div className={cn(className, classes.Form)} data-bs-theme={theme}>
      <Container fluid="md">
        <Row>
          <Col xs={12} md={md}>
            <div className="mb-4">
              {tagline && (
                <Tagline className="d-block mb-3">
                  <span dangerouslySetInnerHTML={{ __html: tagline }} />
                </Tagline>
              )}
              {title && (
                <h2>
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </h2>
              )}
              {description && (
                <div>
                  <span dangerouslySetInnerHTML={{ __html: description }} />
                </div>
              )}
            </div>
            <Form formId={`${forms[0]?.form ? forms[0]?.form : form_id}`} submission_page_url={custom_submission_page_url} custom_submission_page_url={custom_submission_page_url ? custom_submission_page_url : false} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
